import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Trans } from 'react-i18next';
class SurveySuccess extends Component {
    constructor(props) {
        super(props);

        this.updateDimensions = this.updateDimensions.bind(this);

        this.state = {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        }
    }

    componentDidMount() {        
        document.title = "Survey - FleetXPress"
        this.updateDimensions()
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        var ss1 = document.getElementById('survey-success-1')
        var ss2 = document.getElementById('survey-success-2')
        //var ss3 = document.getElementById('survey-success-3')
        this.setState({
            x1: ss1.offsetLeft-22,
            y1: ss1.offsetTop-12,
            x2: ss2.offsetLeft-22,
            y2: ss2.offsetTop-35,
            //x3: ss3.offsetLeft-22,
            //y3: ss3.offsetTop-35
        })
    }

    render() {
        return (
            <div className = "validation-container">
                {
                    /*
                        <svg width="100%" height="100%" style={{position: 'absolute'}}><line x1={this.state.x1} y1={this.state.y1} x2={this.state.x2} y2={this.state.y2} className="registration-step-line"/></svg>
                        <svg width="100%" height="100%" style={{position: 'absolute'}}><line x1={this.state.x2} y1={this.state.y2 + 25} x2={this.state.x3} y2={this.state.y3} className="registration-step-line"/></svg>
                    */
                }
                <div className="registration-navbar">
                    <img src="images/dvms_logo.png" />
                </div>
                <div className="registration-card validation-card">
                    <div className="registration-header">
                        <div className="registration-heading">
                            <Trans>You are now registered with DVMS!</Trans>
                        </div>
                        <div className="registration-subheading">
                            <Trans>To use our vehicles, we need to confirm a few more details: </Trans>
                        </div>
                    </div>
                    <div className="registration-main" style={{flexWrap: 'wrap'}}>
                        <div className="registration-main-inner" style={{width:'auto', margin:'60px auto'}}>
                            
                            <div className="survey-success-item">
                                <img className="survey-success-icon" src="/images/icons/validation/ID.svg" />
                                <div className="survey-success-step" id="survey-success-1">
                                    <div className="survey-vertical-line"></div>
                                    <img src="/images/icons/survey/Checkmark_White.svg" style={{margin: "auto", width: "50%", zIndex: "2"}}/>
                                </div>
                                <div className="survey-success-div">
                                    <div className="survey-success-header">
                                        <Trans>Driver's License</Trans>
                                    </div>
                                    <div className="survey-success-subheader">
                                        <Trans>Confirm your identity</Trans>
                                    </div>
                                </div>
                            </div>
                           
                            <div className="survey-success-item">
                                <img className="survey-success-icon" src="/images/icons/validation/Verification.svg" />
                                <div className="survey-success-step" id="survey-success-2"><img src="/images/icons/survey/Checkmark_White.svg" style={{margin: "auto", width: "50%", zIndex: "2"}}/></div>
                                <div className="survey-success-div">
                                    <div className="survey-success-header">
                                    <Trans>Mobile Number</Trans>
                                    </div>
                                    <div className="survey-success-subheader">
                                        <Trans>Receive notifications via text message</Trans>
                                    </div>
                                </div>
                            </div>
                            {
                                /*
                                <div className="survey-success-item">
                                    <img className="survey-success-icon" src="/images/icons/validation/VLA.svg" />
                                    <div className="survey-success-step" id="survey-success-3"><span>3</span></div>
                                    <div className="survey-success-div">
                                        <div className="survey-success-header">
                                            Review Vehicle Loan Agreement
                                        </div>
                                        <div className="survey-success-subheader">
                                            Expediated check out
                                        </div>
                                    </div>
                                </div>
                                */
                            }
                        </div>
                    </div>
                    <div className="registration-extra">
                        <div style={{margin: "auto"}}> 
                            <img src="/images/icons/validation/Security.svg" className="verification-security" />
                            <span className="registration-extra-text"><Trans>Your information will be secured utilizing 256-bit encryption for sending, receiving, and storing your information.</Trans></span>
                        </div>
                    </div>
                    <div className="registration-single-action">
                        <div className="registration-continue-button" onClick={() => this.props.history.push("/idverification")}>
                            <Trans>Continue</Trans>
                            <i className="fas fa-arrow-right mobile-only" style={{margin: "auto auto auto 10px"}}></i>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
})

export default connect(mapStateToProps,)(SurveySuccess);